interface ExpanderContainerProps {
    children: React.ReactNode;
    isExpanded: boolean;
}

export default function ExpanderContainer(props: ExpanderContainerProps) {
    const { children, isExpanded, ...rest } = props;
    let className = 'expander-container';
    if (isExpanded) {
      className = 'expander-container expanded';
    } else {

    }
    return <div className={className} {...rest}>
      {children}
      </div>;
}